import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { AngularMaterialsModules } from 'src/app/module/materials.module'

@Component({
  selector: 'ddc-loading-skeleton',
  templateUrl: './ddc-loading-skeleton.component.html',
  styleUrls: ['./ddc-loading-skeleton.component.scss'],
  standalone: true,
  imports: [CommonModule, AngularMaterialsModules],
})
export class DdcLoadingSkeletonComponent {}
